import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import CloseIcon from '@public/static/icons/close-icon'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

const PopUpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const PopUpWHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 0.5rem 0;
  z-index: 1;
`
const PopUpWHeaderTitle = styled.div`
  display: flex;
  font-family: ${fontFamilies.bold};
  font-size: 1.25rem;
  align-self: center;
  margin-bottom: 0.5rem;
`
const PopUpWHeaderCloseButton = styled.div`
  display: flex;
  border: 1px solid ${colors.uguPurple};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 1.15rem;
  height: 1.15rem;
  :hover {
    cursor: pointer;
  }
`
const PopUpBody = styled.div`
  display: flex;
  flex-direction: column;
`

const MessageWrapper = styled.div`
  font-size: 1rem;
  line-height: 1.15rem;
  font-family: ${fontFamilies.regular};
  letter-spacing: 0rem;
`

type LearnHowWeEstimatePopUpProps = {
  onClose: () => void
}

const LearnHowWeEstimatePopUp: React.FC<LearnHowWeEstimatePopUpProps> = (
  props
) => {
  const { onClose } = props
  const { t } = useTranslation()
  return (
    <PopUpWrapper>
      <PopUpWHeader>
        <PopUpWHeaderCloseButton onClick={() => onClose()}>
          <CloseIcon
            width="0.625rem"
            height="0.625rem"
            backgroundColor={'none'}
          />
        </PopUpWHeaderCloseButton>
      </PopUpWHeader>
      <PopUpBody>
        <PopUpWHeaderTitle>
          {t('howWeEstimateEarnings', { ns: 'aboutAuthor' })}
        </PopUpWHeaderTitle>
        <MessageWrapper className="mb-12">
          <p className="font-regular tracking-normal">
            {t('estimationExplanationPart1', { ns: 'aboutAuthor' })}
          </p>
          <br />
          <p className="font-regular tracking-normal">
            {t('estimationExplanationPart2', { ns: 'aboutAuthor' })}
          </p>
          <br />
          <p className="font-regular tracking-normal">
            {t('estimationExplanationPart3', { ns: 'aboutAuthor' })}{' '}
            <Link
              href="/pricing"
              style={{ textDecoration: 'underline' }}
              className="font-regular tracking-normal"
            >
              {' '}
              {t('edugramFee', { ns: 'aboutAuthor' })}
            </Link>
            {' ' + t('estimationExplanationPart4', { ns: 'aboutAuthor' })}
          </p>
        </MessageWrapper>
      </PopUpBody>
    </PopUpWrapper>
  )
}

export default LearnHowWeEstimatePopUp
